import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = { class: "card-body" };
const _hoisted_3 = { class: "flex flex-wrap align-items-center justify-content-between gap-3 mb-4" };
const _hoisted_4 = { class: "text-secondary" };
const _hoisted_5 = { class: "user-search" };
const _hoisted_6 = {
    key: 0,
    class: "alert alert-danger",
    role: "alert"
};
const _hoisted_7 = { class: "text-secondary mt-1" };
const _hoisted_8 = { class: "text-secondary mt-1" };
import { computed, onMounted, ref } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import UserHandler from "@/api/User";
import { userErrorMessage } from "./errorMessage";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ListContainer',
    setup(__props) {
        const users = ref([]);
        const search = ref("");
        const loading = ref(false);
        const error = ref("");
        const filteredUsers = computed(() => {
            const query = search.value.trim().toLocaleLowerCase("ru");
            return users.value.filter((user) => [user.name, user.email, ...user.groupNames, ...user.catalogGroupNames]
                .join(" ")
                .toLocaleLowerCase("ru")
                .includes(query));
        });
        async function loadUsers() {
            loading.value = true;
            error.value = "";
            try {
                const response = await UserHandler.getList();
                users.value = response.getResponse();
            }
            catch (err) {
                error.value = userErrorMessage(err);
            }
            finally {
                loading.value = false;
            }
        }
        onMounted(loadUsers);
        return (_ctx, _cache) => {
            const _component_InputText = _resolveComponent("InputText");
            const _component_Button = _resolveComponent("Button");
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-1" }, " Управление учётными записями и доступом к каталогам. ", -1)),
                            _createElementVNode("span", _hoisted_4, "Всего пользователей: " + _toDisplayString(users.value.length), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", {
                                for: "admin-user-search",
                                class: "form-label"
                            }, "Поиск пользователей", -1)),
                            _createVNode(_component_InputText, {
                                id: "admin-user-search",
                                modelValue: search.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                                class: "w-full",
                                placeholder: "Имя, email или группа"
                            }, null, 8, ["modelValue"])
                        ])
                    ]),
                    (error.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("p", null, _toDisplayString(error.value), 1),
                            _createVNode(_component_Button, {
                                label: "Повторить загрузку",
                                icon: "pi pi-refresh",
                                loading: loading.value,
                                onClick: loadUsers
                            }, null, 8, ["loading"])
                        ]))
                        : (_openBlock(), _createBlock(_unref(DataTable), {
                            key: 1,
                            value: filteredUsers.value,
                            loading: loading.value,
                            paginator: "",
                            rows: 20,
                            rowsPerPageOptions: [20, 50, 100],
                            dataKey: "id",
                            responsiveLayout: "scroll"
                        }, {
                            empty: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("Пользователи не найдены.")
                            ])),
                            loading: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("Загрузка пользователей…")
                            ])),
                            default: _withCtx(() => [
                                _createVNode(_unref(Column), {
                                    field: "name",
                                    header: "Пользователь",
                                    sortable: ""
                                }, {
                                    body: _withCtx(({ data }) => [
                                        _createVNode(_component_router_link, {
                                            to: `/admin/users/${data.id}`,
                                            class: "font-semibold"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(data.name || "Без имени"), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["to"]),
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(data.email), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(Column), { header: "Группы" }, {
                                    body: _withCtx(({ data }) => [
                                        _createTextVNode(_toDisplayString(data.groupNames.join(", ") || "Не назначены"), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(Column), { header: "Доступ к каталогам" }, {
                                    body: _withCtx(({ data }) => [
                                        _createElementVNode("div", null, _toDisplayString(data.catalogGroupNames.join(", ") || "Без групп каталогов"), 1),
                                        _createElementVNode("div", _hoisted_8, " Отдельных каталогов: " + _toDisplayString(data.catalogCount), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(Column), {
                                    field: "createdAt",
                                    header: "Дата регистрации"
                                }),
                                _createVNode(_unref(Column), { header: "Действия" }, {
                                    body: _withCtx(({ data }) => [
                                        _createVNode(_component_router_link, {
                                            to: `/admin/users/${data.id}`,
                                            class: "btn btn-outline-primary",
                                            "aria-label": `Изменить пользователя ${data.name || data.email}`
                                        }, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode("Изменить")
                                            ])),
                                            _: 2
                                        }, 1032, ["to", "aria-label"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["value", "loading"]))
                ])
            ]));
        };
    }
});
